import React from 'react';
import { motion } from 'framer-motion';
export function Production() {
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/9iW4zKHF6BLtzvfoDLnLQ9/CARRIER_SWIFT.png',
    caption: 'Logistics & Moving Companies',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/u2RgjUaZAe5uhguq2pGNkL/Electric_Full_Color.png',
    caption: 'Electricians & Contractors',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/asPg3WJ9WG1EfVoZ77e17t/MAC_DEVELOPERS_BACK.png',
    caption: 'Construction & Development',
    position: 'center'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/cTf67maN6zmBwwLYoJopqd/GARDNERS.png',
    caption: 'Landscaping & Outdoor Crews',
    position: 'center'
  }];
  return <section id="work" className="scroll-mt-24 py-24 bg-white" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-95">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-96">
            See How We Make Your Apparel
          </h2>
          <div className="w-24 h-2 bg-black mx-auto" data-id="element-97"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-98">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative overflow-hidden border-4 border-black bg-gray-100" data-id="element-99">
              <div className="w-full aspect-[3/4] sm:aspect-[4/5]" data-id="element-100">
                <img src={img.url} alt={img.caption} style={{
              objectPosition: img.position
            }} className="w-full h-full object-cover filter grayscale-0 group-hover:grayscale transition-all duration-500" data-id="element-101" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-black text-white p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-102">
                <p className="font-display font-bold uppercase tracking-wider text-lg text-center" data-id="element-103">
                  {img.caption}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}